import { useI18n } from "@common/hooks/i18n";
import { usePromise } from "@common/lib/hooks";
import Network from "@common/modules/network/types";
import { sumBy } from "lodash";
import React from "react";
import { filterAggregates } from "../data/lib";
import { type Data } from "../data/types";

export type NetworkVolumeKpiChildrenArgs = {
  isLoading: boolean;
  value: any;
};
type Props = {
  config: Data.NetworkVolumeConfig;
  cycleEndDate: string;
  getAggregates: (cycleEndDate: string) => Promise<Data.Api.GenealogyCycleAggregate[]>;
  getRankOptions: () => Promise<Network.Api.RankOptionItem[]>;

  children: (args: NetworkVolumeKpiChildrenArgs) => any;
};
const NetworkVolumeKpi = (props: Props) => {
  const i18n = useI18n();

  const [aggregates, isLoadingAggregates] = usePromise({
    fn: props.getAggregates,
    args: [props.cycleEndDate],
    shouldLoad: true
  });

  const [rankOptions] = usePromise({
    fn: props.getRankOptions,
    args: [],
    shouldLoad: true
  });

  const value = React.useMemo(() => {
    if (!aggregates || !rankOptions) return i18n.na;

    const filtered = filterAggregates(aggregates, props.config, rankOptions);
    return sumBy(filtered, (x) => x[props.config.aggregateBy]);
  }, [i18n.na, aggregates, props.config, rankOptions]);

  return props.children({
    isLoading: isLoadingAggregates,
    value
  });
};
export default NetworkVolumeKpi;
